import React, { memo, Suspense, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import { useMobile } from 'utils/media';
import Text from 'components/Text';
import { FullSpecialistTeaser } from 'components/SpecialistTeaser';
import Page from '../Page';
import Model from '../../../model';
import FilterBlock from './FilterBlock';
import MobileFilterBlock from './MobileFilterBlock';
import SpecialistsFeedbackFormBlock from './SpecialistsFeedbackFormBlock';
import { eventsData } from 'api/events';
import { TeaserSkeleton } from 'components/SpecialistTeaser/FullSpecialistTeaser';
import { times } from 'utils/render';
import './index.sass';

const { block, el } = bem('specialists');

const title = 'Наши специалисты';

const Specialists = () => {

    const { specialistsData } = Model.specialist;

    return (
        <Page className={ block() } title={ title }>
            <div className={ el('description') }>
                <Text>
                    Мы пригласили в проект лучших специалистов разных методов и направлений. Каждый из них прошел не
                    менее 100 часов личной терапии и продолжает работать с супервизором. Но, кроме прочего, нам важно,
                    что в нашей команде люди, которые разделяют наши ценности и верят в то, что только бережное
                    отношение может исцелять.
                </Text>
            </div>
            <div className={ el('filter') }>
                <Suspense fallback={ <SpecialistsFilterBlock disabled={ true } /> }>
                    <ReadEventsComponent />
                    <SpecialistsFilterBlock />
                </Suspense>
            </div>
            <div className={ el('list') }>
                <Suspense fallback={ times((key) => <TeaserSkeleton key={ key } />, 4) }>
                    <SpecialistList resource={ specialistsData } />
                </Suspense>
            </div>
        </Page>
    )
}

const SpecialistsFilterBlock = ({ disabled = false }) => {
    const { isMobile } = useMobile();
    return isMobile ? <MobileFilterBlock disabled={ disabled } /> : <FilterBlock disabled={ disabled } />;
}

const SpecialistList = observer(({resource}) => {
    resource.read()
    const { filtered: specialists } = Model.specialistFilter;
    const firstBlock = specialists.slice(0, 2);
    const restBlock = specialists.slice(2);
    return <>
        { firstBlock.map((specialist, index) => <FullSpecialistTeaser key={ index } specialist={ specialist } />) }
        <SpecialistsFeedbackFormBlock />
        { restBlock.map((specialist, index) => <FullSpecialistTeaser key={ index } specialist={ specialist } />) }
    </>
});

const ReadEventsComponent = memo(({ resource }) => {
    eventsData.read();
})

export default Specialists;
